<template>
  <v-card
    tile
  >
    <v-img
      :src="cardImage"
    />
    <v-card-title>
      Prosenseマインクラフトビデオレッスン
    </v-card-title>
    <v-card-subtitle>
      マインクラフトで学ぶプログラミング講座
    </v-card-subtitle>
    <v-card-text>
      大人気ゲームのマインクラフトを用いて、プログラミングを学びます。<br/>動画中で講師が１からプログラムの説明をしながら学ぶことができるので、はじめてのお子様でも安心して勉強することができます。
    </v-card-text>
    <v-card-actions>
      <a href="/video-lessons/minecraft/">
        <v-btn
          color="purple"
          text
        >
          無料で視聴する
        </v-btn>
      </a>
    </v-card-actions>
  </v-card>
</template>

<script>
import Image from '@/assets/img/video-lessons/minecraft_programming_for_children.jpg'

export default {
  name: 'VMineCraft',
  data() {
    return {
      cardImage: Image
    }
  }
}
</script>